import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { ContentSection } from '../components/ContentSection';
import { VideoSection } from '../components/VideoSection';
import { BonusSection } from '../components/BonusSection';
import { CertificateSection } from '../components/CertificateSection';
import { OrderBumpSection } from '../components/OrderBumpSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { PricingSection } from '../components/PricingSection';
import { FAQSection } from '../components/FAQSection';
import { SocialProofPopup } from '../components/SocialProofPopup';
export function LandingPage() {
  return <main className="w-full min-h-screen" data-id="element-292">
      <HeroSection data-id="element-293" />
      <ProblemSection data-id="element-294" />
      <SolutionSection data-id="element-295" />
      <ContentSection data-id="element-296" />
      <VideoSection data-id="element-297" />
      <BonusSection data-id="element-298" />
      <CertificateSection data-id="element-299" />
      <OrderBumpSection data-id="element-300" />
      <PricingSection data-id="element-301" />
      <TestimonialsSection data-id="element-302" />
      <FAQSection data-id="element-303" />
      <SocialProofPopup data-id="element-304" />
    </main>;
}